import type {
  SmartTextboxClassNames,
  SmartTextboxStyles,
} from '@tigerabrodioss/fude'

export const FUDE_MENTION_DROPDOWN_SELECTOR = '[data-mention-query]'

const FUDE_MENTION_OPTION_SELECTOR = '[data-mention-option-index]'

export const FUDE_PROMPT_INPUT_CLASSNAMES = {
  tag: 'items-center gap-1.5 rounded-lg border border-border bg-foreground/[0.04] px-2 py-1 text-xs font-medium leading-none text-foreground/80 dark:border-white/10 dark:bg-white/[0.07]',
  tagHighlighted: 'ring-2 ring-foreground/25 dark:ring-white/30',
  dropdown:
    'overflow-hidden rounded-lg border border-border bg-popover p-[5px] text-popover-foreground dark:border-white/10 dark:bg-[#3A3A3A]',
  dropdownItem:
    'rounded-lg px-3 py-2 text-sm text-foreground/90 transition-colors hover:bg-accent hover:text-accent-foreground aria-selected:bg-accent aria-selected:text-accent-foreground dark:hover:bg-white/[0.06] dark:aria-selected:bg-white/[0.08]',
  ghostText: 'text-foreground/50',
  tooltip:
    'rounded-lg border border-border bg-popover px-2 py-1 text-xs text-popover-foreground shadow-md',
  tagWrapper: '-mt-1 relative top-px',
} satisfies SmartTextboxClassNames

export const FUDE_PROMPT_INPUT_STYLES = {
  dropdown: {
    zIndex: 1000,
  },
  ghostText: {
    opacity: 0.5,
  },
  tooltip: {
    border: '1px solid var(--border)',
    backgroundColor: 'var(--popover)',
    color: 'var(--popover-foreground)',
    boxShadow: 'var(--shadow-md)',
  },
} satisfies SmartTextboxStyles

export function syncFudeMentionDropdown(isMentionsLoading: boolean) {
  if (typeof document === 'undefined') {
    return
  }

  const dropdown = document.querySelector<HTMLElement>(
    FUDE_MENTION_DROPDOWN_SELECTOR
  )
  if (!dropdown) {
    return
  }

  const optionNodes = dropdown.querySelectorAll<HTMLElement>(
    FUDE_MENTION_OPTION_SELECTOR
  )
  for (const option of optionNodes) {
    const isSelected = option.getAttribute('aria-selected') === 'true'
    if (isSelected) {
      option.style.color = 'var(--accent-foreground)'
    } else {
      option.style.removeProperty('color')
    }
  }

  const emptyState = dropdown.firstElementChild
  if (!emptyState || emptyState.nextElementSibling) {
    return
  }

  if (!(emptyState instanceof HTMLElement)) {
    return
  }

  if (isMentionsLoading) {
    emptyState.replaceChildren()
    emptyState.className = 'space-y-2 px-3 py-3'

    for (let index = 0; index < 3; index += 1) {
      const skeleton = document.createElement('div')
      skeleton.className = 'h-3 animate-pulse rounded bg-muted'
      skeleton.style.width = index === 2 ? '70%' : '100%'
      emptyState.appendChild(skeleton)
    }
    return
  }

  emptyState.style.color = 'var(--muted-foreground)'

  if (emptyState.textContent?.trim() === 'No mentions') {
    emptyState.textContent = 'No emails or automations'
  }
}
